<template>
  <div class="row small-gutters mt-2">
    <div v-if="!isLoaded" style="height: 258px;" class="d-flex align-items-center justify-content-center w-100">
      <spinner />
    </div>
    <template v-else>
      <div v-for="(category, key) in expertises" :key="key" class="col-6"
        style="height: 129px;"
      >
        <div class="t-500 mb-1"
          :class="{
            't-blue': category.length > 0,
            't-secondary': category.length === 0
          }"
        >{{ key | humanize | capitalize }}</div>
        <div v-for="expertise in category" :key="expertise.name" class="y-a-label"
          :title="expertise.name"
        >
          <button type="button" class="btn link-button t-sm px-2 d-flex justify-content-between mb-1 w-100"
            @click.stop="$emit('clickExpertise', key, expertise.name)"
          >
            <span class="t-overflow">{{ expertise.name }}</span>
            <span>{{ expertise.count | formatNumberShort }}</span>
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'

export default {
  name: 'expertises',
  components: {
    Spinner
  },
  props: {
    isLoaded: {
      type: Boolean,
      default: false
    },
    expertises: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
